import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import Icons from "../../myIcon/Icons";
import Slider from "react-slick";
import { Modal } from "react-bootstrap";

export default function HomeVideoslider() {
  const sliderRef = useRef(null);
  const [modalShow, setModalShow] = useState(false);
  const [activeVideo, setActiveVideo] = useState("");
  const [progress, setProgress] = useState(0);

  const sliderData = [
    {
        image: "/image/videothumb-1.webp",
        description: "Sonams Label Was Featured In Bigg Boss 17 Ft. Sana Raees Khan",
        title: "Bb17 X Sonams Label",
        videoLink: "../video/bigg-boss.mp4"
    },
    {
        image: "/image/videothumb-3.webp",
        description: "Words of Affirmation and trust from the very first client",
        title: "Words of Trust",
        videoLink: "../video/words-trust.mp4"
    },
    {
        image: "/image/videothumb-2.webp",
        description: "A heartfelt testimonial celebrating Sonam’s couture artistry",
        title: "Crafted With Pure Trust",
        videoLink: "../video/crafted-with-trust.mp4"
    },
    {
        image: "/image/videothumb-4.webp",
        description: "Sonam was awarded Best Bridal and Groom Wear - Designer of the Year",
        title: "The Big Awards",
        videoLink: "../video/award.mp4"
    },
  ];


  const settings = {
    dots: false,
    arrows: false,
    infinite: true,
    speed: 1500,     
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnHover: false,
    cssEase: "ease",
    responsive: [
        {
          breakpoint: 991,
          settings: { slidesToShow: 3 },
        },
        {
            breakpoint: 767,
            settings: { slidesToShow: 2 },
        },
        {
            breakpoint: 599,
            settings: { slidesToShow: 1,}
        },
    ],
    beforeChange: (oldIndex, nextIndex) => {
      let totalSlides = 0;
      try {
        totalSlides =
          sliderRef.current &&
          sliderRef.current.innerSlider &&
          sliderRef.current.innerSlider.props &&
          sliderRef.current.innerSlider.props.children
            ? sliderRef.current.innerSlider.props.children.length
            : 0;
      } catch (e) {
        totalSlides = 0;
      }

      if (totalSlides <= 1) {
        setProgress(0);
        return;
      }

      const calc = (nextIndex / (totalSlides - 1)) * 100;
      setProgress(calc);
    },
  };

  const handlePrev = () => sliderRef.current && sliderRef.current.slickPrev();
  const handleNext = () => sliderRef.current && sliderRef.current.slickNext();


  // ✅ Pause slider when modal opens & resume when modal closes
  useEffect(() => {
    if (modalShow) {
      sliderRef.current?.slickPause();
    } else {
      sliderRef.current?.slickPlay();
    }
  }, [modalShow]);


  return (
    <>
    <section className="home-videoslider bodygap">
        <h4 className="heading center-heading">Treasured Moments, Timeless Words</h4>
        
        <Slider {...settings} ref={sliderRef}>
            {sliderData.map((item, index) => (
            <div key={index}>
                <div className="videoslider-box">
                    <img src={item.image} className="img-responsive" alt="video" loading="lazy"/>
                    <div className="videoslider-inner">
                        <p>{item.description}</p>
                        <div>
                            <span>{item.title}</span>
                            <Link onClick={() => { setActiveVideo(item.videoLink); setModalShow(true);}}><Icons name="play" /></Link>
                        </div>
                    </div>
                </div>
            </div>
            ))}
        </Slider>

        <div className="exclusive-controls">
            <div className="slider-progress" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow={Math.round(progress)} style={{
                backgroundSize: `${progress}% 100%`,
                transition: `background-size ${settings.speed}ms ease`, }}>
                <span className="slider__label sr-only"></span>
            </div>
        </div>

        <div className="default-arrowleft" onClick={handlePrev}><Icons name="arrowLeft" /></div>
        <div className="default-arrowright" onClick={handleNext}><Icons name="arrowRight" /></div>
    </section>


      <Modal className="homevideo-popup" show={modalShow} onHide={() => setModalShow(false)} size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
          <Modal.Body>
              <button className="popup-close" onClick={() => setModalShow(false)}><Icons name="cross" /></button>
              <iframe
                className="video-player"
                src={`${activeVideo}?autoplay=1`}
                allow="autoplay; encrypted-media"
                allowFullScreen
                title="Video"
                frameBorder="0"/>
          </Modal.Body>
      </Modal> 
    </>
  )
}
